import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiUserCheck, FiMapPin, FiZap, FiAward } = FiIcons;

const WhyUs = () => {
  const reasons = [
    { title: 'Direct Access', desc: 'No account managers or handoffs. Speak directly to the person building your project.', icon: FiUserCheck },
    { title: 'Local', desc: 'Built in Rapid City. We understand the local market and your community.', icon: FiMapPin },
    { title: 'Built in Rapid City', desc: 'We are part of the local ecosystem, supporting South Dakota businesses.', icon: FiZap },
    { title: 'Proven', desc: 'More than a dozen shipped consumer products. We know how to get to the finish line.', icon: FiAward },
  ];

  return (
    <section className="py-24 bg-[#07113a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-white uppercase tracking-tight">Why work with Crucible Lab</h2>
        </div>
        
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {reasons.map((reason, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="space-y-6 bg-[#2a3658]/30 p-8 rounded-[32px] border border-[#344271] hover:border-[#3b82f6]/30 transition-all"
            >
              <div className="w-14 h-14 bg-[#07113a] rounded-2xl flex items-center justify-center text-[#3b82f6] border border-[#344271]">
                <SafeIcon icon={reason.icon} className="text-2xl" />
              </div>
              <div>
                <h4 className="text-xl font-black text-white uppercase tracking-tight mb-3">{reason.title}</h4>
                <p className="text-[#94a3b8] leading-relaxed font-medium">{reason.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;